module.exports = __webpack_public_path__ + "static/media/old_computer_hq.412c0427.jpg";